import api from './api'

const parsePositiveInt = (value) => {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}

export const getSessionUserNoCache = async () => {
  const response = await api.get('/auth/me', {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
  return response?.data?.user || null
}

export const getOperationalClients = async () => {
  const response = await api.get('/clients')
  return Array.isArray(response?.data) ? response.data : []
}

export const getOperationalProductsByClient = async (clientId) => {
  const parsedClientId = parsePositiveInt(clientId)
  if (!parsedClientId) return []

  const response = await api.get(`/products/by-client/${parsedClientId}`)
  return Array.isArray(response?.data) ? response.data : []
}

export const activateOperationalContext = async ({ clientId, productId }) => {
  const parsedClientId = parsePositiveInt(clientId)
  const parsedProductId = parsePositiveInt(productId)

  if (!parsedClientId || !parsedProductId) {
    throw new Error('clientId y productId deben ser enteros positivos')
  }

  const response = await api.post('/auth/operational-context', {
    clientId: parsedClientId,
    productId: parsedProductId,
  })

  return response?.data || null
}
